import React from 'react';
import { useLocation } from "react-router-dom";

import PotreeViewer from "../viewer/PotreeViewer";

function ViewerPageWrapper() {
  const {state} = useLocation();
  const { filename, description, metadata, hierarchy, octree } = state;

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        width: "100%",
        height: "100%",
        overflow: "hidden",
      }}
    >
      <PotreeViewer
        filename={filename}
        description={description}
        metadata={metadata} 
        hierarchy={hierarchy} 
        octree={octree}
      />
    </div>
  );
}

export default ViewerPageWrapper;
